( function () {
	'use strict';

	function TemplateCategories ( $modal, TOOLTIP_MESSAGES ) {
		function link ( scope ) {
			function openModal () {
				var modalInstance = $modal.open( {
					'templateUrl'  : '/templates/templates-new/template-categories/template-categories-modal.html',
					'controller'   : 'TemplateCategoriesModalController',
					'controllerAs' : 'vm',
					'keyboard'     : false,
					'size'         : 'lg',
					'resolve'      : {
						'collection' : function () {
							return scope.collection;
						},

						'mode' : function () {
							return scope.mode;
						}
					}
				} );

				modalInstance.result.then( function ( newCollection ) {
					scope.collection = newCollection;
				} );
			}

			scope.openModal = openModal;
			scope.tooltip   = TOOLTIP_MESSAGES;
		}

		return {
			'templateUrl'      : '/templates/templates-new/template-categories/template-categories.html',
			'restrict'         : 'E',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'link'             : link,
			'scope'            : {
				'collection' : '='
			}
		};
	}

	angular
		.module( 'app.templates' )
		.directive( 'templateCategories', TemplateCategories );
} )( );
